// extracted by mini-css-extract-plugin
module.exports = {"newMessage":"messages_newMessage__7X15K","messageRow":"messages_messageRow__D1ccH","half":"messages_half___RzbY","eventDetails":"messages_eventDetails__rQBZV"};